export type SchoolClass = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  name: string;
};
